"use client";

import { GoogleTagManager } from "@next/third-parties/google";
import { usePathname } from "next/navigation";
import Script from "next/script";
import { useEffect, useRef, useState } from "react";
import { useClientConfig } from "@/context/clientConfig";
import { useSiteAnalyticsContext } from "@/context/siteAnalytics";
import SiteAnalyticsService from "@/services/SiteAnalyticsService";

interface GTMScriptProps {
  gtmIds: string[];
}

export default function GTMScript({ gtmIds }: GTMScriptProps) {
  const analytics = useSiteAnalyticsContext();
  const pathname = usePathname();
  const isFirstRender = useRef(true);
  const { gtm: gtmConfig } = useClientConfig();
  const [siteAnalytics] = useState(
    () => new SiteAnalyticsService(analytics, gtmConfig),
  );
  const initialDataLayer = siteAnalytics.getInitialDataLayer();

  const dataLayerScript = `
    window.dataLayer = ${JSON.stringify(initialDataLayer)};
  `;

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    SiteAnalyticsService.resetDataLayer();
    siteAnalytics.setInitialDataLayer();
  }, [pathname, siteAnalytics]);

  return (
    <>
      <Script
        id="dataLayer-script"
        dangerouslySetInnerHTML={{
          __html: dataLayerScript,
        }}
      />
      {gtmIds.map((gtmId) => (
        <GoogleTagManager key={gtmId} gtmId={gtmId} />
      ))}
    </>
  );
}
